<template>
    <div class="FluidBackground" ref="canvasWrapper"></div>
</template>

<script>
import * as PIXI from 'pixi.js'

export default {
    name: 'FluidBackground',
    props: ['image', 'name'],
    data () {
        return {
        }
    },
    mounted: function(){
        this.setCanvas()
        this.resizeTimer
        window.addEventListener('resize', this.resize);
    },
    methods: {
        resize: function(){
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(_ => {
                this.destroyCanvas()
                setTimeout(this.setCanvas, 0)
            }, 250);
        },
        backgroundCover: function(bgSize, inputSprite, type, forceSize) {
            var sprite = inputSprite;
            var bgContainer = new PIXI.Container();
            var mask = new PIXI.Graphics().beginFill(0x8bc5ff).drawRect(0,0, bgSize.x, bgSize.y).endFill();
            bgContainer.mask = mask;
            bgContainer.addChild(mask);
            bgContainer.addChild(sprite);

            var sp = {x:sprite.width,y:sprite.height};
            if(forceSize) sp = forceSize;
            var winratio = bgSize.x/bgSize.y;
            var spratio = sp.x/sp.y;
            var scale = 1;
            var pos = new PIXI.Point(0,0);
            if(type == 'cover' ? (winratio > spratio) : (winratio < spratio)) {
                //photo is wider than background
                scale = bgSize.x/sp.x;
                pos.y = -((sp.y*scale)-bgSize.y)/2
            } else {
                //photo is taller than background
                scale = bgSize.y/sp.y;
                pos.x = -((sp.x*scale)-bgSize.x)/2
            }

            sprite.scale = new PIXI.Point(scale,scale);
            sprite.position = pos;

            return bgContainer;
        },
        setCanvas: function(){
            // disable PIXI console message
            PIXI.utils.skipHello();

            var renderer = new PIXI.autoDetectRenderer(this.$refs.canvasWrapper.offsetWidth, this.$refs.canvasWrapper.offsetHeight,  { transparent: true });

            this.$refs.canvasWrapper.innerHTML = ''
            this.$refs.canvasWrapper.appendChild(renderer.view);

            renderer.autoResize = true;
            this.renderer = renderer

            var stage = new PIXI.Container();
            this.stage = stage
            stage.interactive = true;

            // displacement -----
            var displacementSprite  = PIXI.Sprite.fromImage(require('../../assets/images/clouds.jpg'));
            var displacementFilter  = new PIXI.filters.DisplacementFilter( displacementSprite );

            this.displacementFilter = displacementFilter

            displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;

            stage.filters = [displacementFilter];

            displacementFilter.scale.x = 0;
            displacementFilter.scale.y = 0;

            stage.addChild( displacementSprite );

            var imageSrc = this.image,
                loader = new PIXI.loaders.Loader()

            loader.add(this.name, imageSrc)
            loader.load((loader, resources) => {

                this.setImage(resources)

                var render = new PIXI.ticker.Ticker();
                render.autoStart = true;
                this.render = render

                render.add(function( delta ) {
                    renderer.render( stage );
                });
            });

            this.loader = loader
        },
        setImage: function(resources){
            for(let i = this.stage.children.length - 1; i >= 0; i--)
                this.stage.removeChild(this.stage.children[i])

            let texture = resources ? resources[this.name].texture : this.loader.resources[this.name].texture,
                image = this.backgroundCover({x: this.$refs.canvasWrapper.offsetWidth, y: this.$refs.canvasWrapper.offsetHeight}, new PIXI.Sprite(texture), 'cover');

             this.stage.addChild(image);
        },
        toggleDisplacement: function(displace){
            var xVal, yVal,
                displacementFilter = this.displacementFilter

            if(displace){
                xVal = -30;
                yVal = -25;
                TweenMax.to( displacementFilter.scale, 0.5, { x: "+=" + Math.sin( xVal ) * 1200 + "", y: "+=" + Math.cos( yVal ) * 200 + ""});
            }
            else{
                TweenMax.to( displacementFilter.scale, 0.5, { x: 0, y: 0});
            }
        },
        destroyCanvas: function(){
            this.stage.destroy(true);
            this.stage = null;
            this.$refs.canvasWrapper.removeChild(this.renderer.view);
            this.renderer.destroy( true );
            this.renderer = null;
        }
    },
    beforeDestroy: function(){
        window.removeEventListener('resize', this.resize);
        this.destroyCanvas()
    }
}
</script>

<style lang="scss">
    @import './fluidBackground';
</style>



// WEBPACK FOOTER //
// src/components/FluidBackground/FluidBackground.vue